(ns frontend.test.select.view
  (:require [frontend.test.select.event :as event]
            [frontend.test.select.model :as model]
            [frontend.test.select.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.select.async-multi-select :as async-multi-select]
            [ui.components.select.async-select :as async-select]
            [ui.components.select.multi-select :as multi-select]
            [ui.components.select.select :as select]
            [ui.util :as uu]))

(defn view
  []
  [:div
   {:class "p-2 flex flex-col gap-4"}
   [:div
    [:h2
     {:class ""}
     "Select"]
    [:p
     {:class "mb-2 text-sm"}
     "Use this when you have the options in memory - single select"]
    [select/view
     {:value               @(rf/subscribe [::sub/single-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-single-select-value selected-options]))
      :options             model/sample-memory-options}]]
   [:p
    {:class "max-w-48"}
    "Limited container size"
    [select/view
     {:value               @(rf/subscribe [::sub/single-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-single-select-value selected-options]))
      :options             model/sample-memory-options}]]

   [:div
    [:h2
     {:class ""}
     "Multi-select"]
    [:p
     {:class "mb-2 text-sm"}
     "Use this when you have the options in memory - multi select"]
    [multi-select/view
     {:value               @(rf/subscribe [::sub/multi-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-multi-select-value selected-options]))
      :options             model/sample-memory-options}]]

   [:p
    {:class "max-w-48"}
    "Limited container size"
    [multi-select/view
     {:value               @(rf/subscribe [::sub/multi-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-multi-select-value selected-options]))
      :options             model/sample-memory-options}]]

   [:div
    [:h2
     {:class ""}
     "Async select"]
    [:p
     {:class "mb-2 text-sm"}
     "Use this when you have to load/resolve the options - single select"]
    [async-select/view
     {:value               @(rf/subscribe [::sub/async-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-async-value selected-options]))
      :get-options         (fn [query callback-js]
                             (uu/timeout 500
                                         #(rf/dispatch [::event/query-async-select query callback-js])))}]]

   [:p
    {:class "max-w-48"}
    [:span
     {:class "block mb-2 text-sm"}
     "Limited container size"]
    [async-select/view
     {:value               @(rf/subscribe [::sub/async-select-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-async-value selected-options]))
      :get-options         (fn [query callback-js]
                             (uu/timeout 500
                                         #(rf/dispatch [::event/query-async-select query callback-js])))}]]
   [:div
    [:h2
     {:class ""}
     "Async multi select"]
    [:p
     {:class "mb-2 text-sm"}
     "Use this when you have to load/resolve the options - multi select"]
    [async-multi-select/view
     {:value               @(rf/subscribe [::sub/async-select-multi-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-async-multi-value selected-options]))
      :get-options         (fn [query callback-js]
                             (uu/timeout 500
                                         #(rf/dispatch [::event/query-async-select query callback-js])))}]]

   [:p
    {:class "max-w-48"}
    [:span
     {:class "block mb-2 text-sm"}
     "Limited container size"]
    [async-multi-select/view
     {:value               @(rf/subscribe [::sub/async-select-multi-value])
      :open-menu-on-focus? true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-async-multi-value selected-options]))
      :get-options         (fn [query callback-js]
                             (uu/timeout 500
                                         #(rf/dispatch [::event/query-async-select query callback-js])))}]]
   [:div
    [:p
     {:class "mb-2 text-sm"}
     "This is for styling loading message"]
    [async-multi-select/view
     {:value               @(rf/subscribe [::sub/async-select-multi-value])
      :open-menu-on-focus? true
      :is-loading?         true
      :on-change           (fn [selected-values selected-options]
                             (rf/dispatch [::event/set-async-multi-value selected-options]))
      :get-options         (fn [query callback-js]
                                ;; do not call callback -> always loading
                             nil)}]]])
